import { useState } from 'react';
import { Link } from '@inertiajs/react';
import { useTranslation } from 'react-i18next';
import { Cookie } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { isNative } from '@/lib/capacitor';

const STORAGE_KEY = 'cookie_consent';

export default function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(
    () => !isNative() && !localStorage.getItem(STORAGE_KEY),
  );

  if (!visible) return null;

  function handleAccept() {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  }

  return (
    <div className="fixed inset-x-0 bottom-[calc(3.5rem+env(safe-area-inset-bottom))] z-40 flex justify-center px-4 md:bottom-4">
      <div className="flex w-full max-w-lg items-center gap-3 rounded-2xl border border-border bg-card p-4 shadow-ios">
        <Cookie className="h-5 w-5 shrink-0 text-muted-foreground" />
        <p className="flex-1 text-sm text-muted-foreground">
          {t('cookies.message')}{' '}
          <Link
            href="/privacy#cookies-and-storage"
            className="underline underline-offset-2"
          >
            {t('cookies.learnMore')}
          </Link>
        </p>
        <Button size="sm" onClick={handleAccept} className="shrink-0">
          {t('cookies.accept')}
        </Button>
      </div>
    </div>
  );
}
